import React from 'react';
import AppSpinner from './AppSpinner';

/**
 * Lazy-route and auth-gate fallback — use `embedded` inside Layout outlet routes.
 */
export default function PageSuspenseFallback({ embedded = false, label }) {
  return (
    <div
      className={
        embedded
          ? 'flex flex-col items-center justify-center gap-3 py-16 min-h-[12rem]'
          : 'flex flex-col items-center justify-center gap-3 min-h-[50vh] sm:min-h-screen'
      }
    >
      <AppSpinner size={embedded ? 'md' : 'lg'} />
      {label ? (
        <p className="text-xs text-slate-500 dark:text-slate-400">{label}</p>
      ) : null}
    </div>
  );
}
